var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZscaler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3459 24.2644C36.7209 26.6586 34.6728 27.9855 32.567 28.1298C31.2401 30.8702 26.5382 32.7163 22.4709 30.6971C20.7401 30.9567 19.7882 30.524 19.0382 29.6875C20.5382 27.7836 25.0382 24.3221 30.5478 26.1394C33.4901 27.0913 34.2689 24.8702 33.5189 24.0336C30.7497 20.8894 24.4901 23.7163 24.2593 23.9471C26.7113 20.1682 35.5382 19.1298 36.3459 24.2644ZM27.9228 19.9375C27.9228 19.9375 25.9324 19.2163 23.1055 20.4278C22.9901 20.399 22.8747 20.3413 22.7593 20.2836C25.4709 18.4952 27.8363 17.7163 29.8843 18.0336C28.6439 16.6202 22.7593 15.5817 19.3555 18.9567C15.1728 18.1202 12.2593 21.6682 12.4036 24.899C12.5478 28.1298 16.0959 30.1778 18.1151 29.6298C18.1728 29.6298 18.2016 29.6298 18.2593 29.6298C18.7209 27.4663 20.5382 22.5048 27.9228 19.9375Z",
    fill: "#236BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZscaler);
export default __webpack_public_path__ + "static/media/Zscaler.1b018ef40eac9b3b39cd1a4ec134298d.svg";
export { ForwardRef as ReactComponent };